import AdminContent from "./components/AdminContent";
import { AdminProvider } from "./provider/AdminContext";

const index = () => {
  return (
    <AdminProvider>
      <AdminContent />
    </AdminProvider>
  );
};

export default index;
